// Code review - In Progress
// Documentation - In Progress
import { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import "react-toastify/dist/ReactToastify.css";
import {
  ResourcesMasterExportHeader,
  ResourcesMasterHeader,
} from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import MainPopup from "../popup-containers/MainPopup";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import ResourceMasterPopup from "../popup-containers/ResourcesMasterPopup";
import toast, { Toaster } from "react-hot-toast";
import * as XLSX from "sheetjs-style";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import GridPage from "../components/GridPage";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import FileUpload from "../ReusableComponents/FileUpload";
import { useLocation } from "react-router-dom";
import { useUserCapability } from "../components/ConstantReducerProvider";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";

function ResourcesMaster() {
  const location = useLocation();
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  // All visible functionality useState hooks handling.
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);

  // Services Category Master insert and edit useState hooks handling .
  const [resourcesCountry, setResourcesCountry] = useState("");
  const [resourcesState, setResourcesState] = useState("");
  const [resourcesLocation, setResourcesLocation] = useState("");
  const [mstResourcesId, setMstResourcesId] = useState("");

  const [resourceFields, setResourceFields] = useState({
    resourcesName: "",
    resourcesPosition: "",
    resourcesState: "",
    resourcesLocation: "",
    showImage: "",
  });

  const [resourceFieldsError, setResourceFieldsError] = useState({
    resourcesNameError: "",
    resourcesPositionError: "",
    resourcesStateError: "",
    resourcesLocationError: "",
    showImageError: "",
  });

  // Bind dropdown value and bind data value useState hooks handling.
  const [bindState, setBindStateDD] = useState([]);
  const [bindLocation, setBindLocationDD] = useState([]);
  const [bindLocation1, setBindLocationDD1] = useState([]);
  const [bindResourcesMasterDatas, setBindResourcesMasterDatas] = useState([]);
  const [currentData, setCurrentData] = useState({});
  const [popupdata, setPopupdata] = useState({});
  const [rowIndex, setRowIndex] = useState("");
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [getLocationDatas, setGetLocationDatas] = useState([]);

  const [isOpen, setIsOpen] = useState(false);

  // This is Services Resources grid page add button visible handling functionality .
  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    setResourceFields({
      resourcesState: userProfileDatas[0].MstStateId,
      resourcesLocation: userProfileDatas[0].MstLocationId,
    });
  };

  // This is ovrall cancel button visible handling functionality .
  const cancel = () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    resourcesData(userProfileDatas);
    setSubmitBtnDisabled(false);
    setIsLoading(false);
    setResourceFields({
      resourcesName: "",
      resourcesPosition: "",
      resourcesState: "",
      resourcesLocation: "",
      showImage: "",
    });

    setResourceFieldsError({
      resourcesNameError: "",
      resourcesPositionError: "",
      resourcesStateError: "",
      resourcesLocationError: "",
      showImageError: "",
    });
  };

  const handleEdit = async (rowIndex) => {
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);

    setMstResourcesId(bindResourcesMasterDatas[rowIndex].MstResourcesId);

    setResourceFields({
      ...resourceFields,
      resourcesName: bindResourcesMasterDatas[rowIndex].ResourcesName,
      resourcesPosition: bindResourcesMasterDatas[rowIndex].ResourcesPosition,
      resourcesState: bindResourcesMasterDatas[rowIndex].MstStateId,
      resourcesLocation: bindResourcesMasterDatas[rowIndex].MstLocationId,
      showImage: bindResourcesMasterDatas[rowIndex].ResourcesPhoto,
    });
  };

  const validate = (flag) => {
    // Initialize an object to store validation errors for each field
    const errors = {};

    if (flag === 1 || flag === 2) {
      // Use fallback values to avoid errors
      if (!resourceFields.resourcesState) {
        errors.resourcesState = "Select State";
      }
      if (!resourceFields.resourcesLocation) {
        errors.resourcesLocation = "Select Branch / Project";
      }
      if ((resourceFields.resourcesName || "").trim() === "") {
        errors.resourcesName = "Enter Resource Person Name";
      } else if (!/^[A-Za-z -]+$/.test(resourceFields.resourcesName)) {
        errors.resourcesName = "Only Alphabet, space and - allowed";
      }

      if ((resourceFields.resourcesPosition || "").trim() === "") {
        errors.resourcesPosition = "Enter Position";
      } else if (!/^[A-Za-z -]+$/.test(resourceFields.resourcesPosition)) {
        errors.resourcesPosition = "Only Alphabet, space and - allowed";
      }
    }

    setResourceFieldsError({
      ...resourceFieldsError,
      resourcesNameError: errors.resourcesName || "",
      resourcesPositionError: errors.resourcesPosition || "",
      resourcesStateError: errors.resourcesState || "",
      resourcesLocationError: errors.resourcesLocation || "",
    });

    return errors;
  };

  // This function is helped to the edit, viwe, delete, block and unblock flag passing and hanling the API
  // response for those all and passing the rowindex for Resources.
  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);
    const firstNameValidation = validate(flag);
    if (Object.keys(firstNameValidation).length !== 0) {
      setIsOpen(true);
    }

    if (Object.keys(firstNameValidation).length === 0) {
      setIsOpen(false);
      var createdBy = sessionStorage.getItem("createdBy");
      if (flag == 1 || flag == 2) {
        const data = {
          mstResourcesId: mstResourcesId ? mstResourcesId : 0,
          resourcesName: resourceFields.resourcesName,
          resourcesPosition: resourceFields.resourcesPosition,
          mstCountryId: 1,
          mstStateId: resourceFields.resourcesState,
          mstLocationId: resourceFields.resourcesLocation,
          resourcesPhoto: resourceFields.showImage,
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI([data], "ResourcesAPI/IUDResources");
        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Resource Person added successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to add Resource Person data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Resource Person updated successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to update Resource Person data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      } else {
        const data = {
          mstResourcesId: bindResourcesMasterDatas[items].MstResourcesId,
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI([data], "ResourcesAPI/IUDResources");
        if (flag == 3) {
          if (response.data.Table[0].Result === "D") {
            toast.success(
              "Resource Person data deleted successfully 🗑️",
              1000,
              cancel(),
            );
            cancel();
          } else {
            toast.error("Failed to delete Resource Person data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 4) {
          if (response.data.Table[0].Result === "B") {
            toast.success(
              "Resource Person data blocked successfully 🚫",
              1000,
              cancel(),
            );
            cancel();
          } else {
            toast.error("Failed to block Resource Person data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 5) {
          if (response.data.Table[0].Result === "UB") {
            toast.success(
              "Resource Person data unblocked successfully ✅",
              1000,
              cancel(),
            );
            cancel();
          } else {
            toast.error("Failed to unblock Resource Person data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      }
    } else {
      setSubmitBtnDisabled(false);
      setIsLoading(false);
    }
  };

  // This function is helped to the viwe, delete, block and unblock
  // input value via rowindex passing for Resources .
  const handleResources = (rowIndex, flag) => {
    setpopUpOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    const StateRowData = bindResourcesMasterDatas[rowIndex];
    const StateInfo = bindState.find(
      (SD) => SD.value === StateRowData.MstStateId,
    );
    const ResultState = {
      value: StateRowData.MstStateId,
      label: StateInfo ? StateInfo.label : "Unknown",
    };
    setResourcesState(ResultState);

    const locationRowData = bindResourcesMasterDatas[rowIndex];
    const LocationInfo = bindLocation.find(
      (L) => L.value === locationRowData.MstLocationId,
    );
    const ResultLocation = {
      value: locationRowData.MstLocationId,
      label: LocationInfo ? LocationInfo.label : "Unknown",
    };
    setResourcesLocation(ResultLocation);

    const AutoDropdownPopupdata = [ResultLocation, ResultState];
    setPopupdata(AutoDropdownPopupdata);
    setCurrentData(bindResourcesMasterDatas[rowIndex]);
    setMstResourcesId(bindResourcesMasterDatas[rowIndex].MstResourcesId);
  };

  // This hook function is helped to bind dropdown value and bind all data
  //from Resources master table.
  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          getSelectedLocationData(),
          bindDrpStateData(),
          getSelectedLocation(),
          resourcesData(userProfileDatas),
        ]);
      } catch (error) {
        console.error("Error in fetchData:", error);
      }
      setIsLoading(true);
      const getSelectedLocationData = async () => {
        const locationResponse = await BindAPI("LocationAPI/GetLocation");
        const locationData = locationResponse.data.Table.map((item) => ({
          value: item.MstLocationId,
          label: item.LocationName_en,
        }));
        setBindLocationDD(locationData);
      };

      getSelectedLocationData();
      bindDrpStateData();
      getSelectedLocation();
      resourcesData(userProfileDatas);
    };
    setIsLoading(false);
    fetchData();
  }, [userProfileDatas]);

  useEffect(() => {
    if (location.pathname === "/resourcesmaster") {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
    }
  }, [location, userProfileDatas]);

  // ✅ Resources Data
  const resourcesData = async (userProfileDatas) => {
    if (!userProfileDatas || !userProfileDatas[0]) return;
    setIsLoading(true);

    try {
      const payload = {
        mstOrganizationStructureId: userProfileDatas[0].MstOrganizationId,
        mstBranchId: userProfileDatas[0].MstLocationId,
      };

      const response = await BindPostAPI(
        [payload],
        "ResourcesAPI/BindResources",
      );
      setBindResourcesMasterDatas(response?.data?.Table ?? []);
    } catch (error) {
      console.error("Error fetching resources:", error);
      setBindResourcesMasterDatas([]);
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Location Dropdown Data
  const getSelectedLocationData = async () => {
    try {
      const response = await BindAPI("LocationAPI/GetLocation");
      const locationData =
        response?.data?.Table?.map((item) => ({
          value: item.MstLocationId,
          label: item.LocationName_en,
        })) ?? [];
      setBindLocationDD(locationData);
    } catch (error) {
      console.error("Error fetching location dropdown:", error);
      setBindLocationDD([]);
    }
  };

  // ✅ Location Table Data
  const getSelectedLocation = async () => {
    try {
      const response = await BindAPI("LocationAPI/GetLocation");
      setGetLocationDatas(response?.data?.Table ?? []);
    } catch (error) {
      console.error("Error fetching location table:", error);
      setGetLocationDatas([]);
    }
  };

  // ✅ State Dropdown Data
  const bindDrpStateData = async () => {
    try {
      const response = await BindAPI("MasterDataAPI/BindAllMasterData");
      const stateDD =
        response?.data?.Table?.map((m) => ({
          value: m.MstStateId,
          label: m.StateName_en,
        })) ?? [];
      setBindStateDD(stateDD);
    } catch (error) {
      console.error("Error fetching state data:", error);
      setBindStateDD([]);
    }
  };

  //State DropDown Value End

  useEffect(() => {
    // Find the selected state in getLocationDatas
    const stateSelectedValue = getLocationDatas.find(
      (item) => item.MstStateId == resourceFields.resourcesState, // Replace with the desired MstStateId
    );

    if (stateSelectedValue) {
      const locationLabels = getLocationDatas
        .filter((item) => item.MstStateId === stateSelectedValue.MstStateId)
        .map((item) => ({
          MstLocationId: item.MstLocationId,
          LocationName_en: item.LocationName_en,
        }));

      const locationSelected = locationLabels.map((LC) => ({
        value: LC.MstLocationId, // Replace with the appropriate value
        label: LC.LocationName_en,
      }));
      setBindLocationDD1(locationSelected);
    } else {
    }
  }, [resourceFields.resourcesState]);

  const handleUserFieldsChange = (value, name) => {
    setResourceFields({
      ...resourceFields,
      [name]: value,
    });
  };

  const handleShowImage = (showImage) => {
    setResourceFields({
      ...resourceFields,
      showImage: showImage || "",
    });
    setResourceFieldsError({ ...resourceFieldsError, showImageError: "" });
  };
  const createdBy = sessionStorage.getItem("createdBy");
  const handleExport = async () => {
    try {
      if (userProfileDatas?.[0]) {
        const payload = {
          mstOrganizationStructureId: userProfileDatas[0].MstOrganizationId,
          mstBranchId: userProfileDatas[0].MstLocationId,
        };

        const response = await BindPostAPI(
          [payload],
          "ResourcesAPI/BindResourcesExport",
        );
        const rows = response?.data?.Table || [];
        if (rows.length === 0) {
          await IUDAPI(
            {
              mstUserId: parseInt(createdBy, 10),
              sp: "RESOURCES MASTER",
              action: "EXCEL EXPORT",
              status: "FAILED",
              tableName: "mst_resources",
              description: "No data available to export",
            },
            "Log/IUDLog",
          );

          toast.error("No data available to export", {
            duration: 1000,
            position: "top-center",
          });

          return;
        } else {
          await IUDAPI(
            {
              mstUserId: parseInt(createdBy, 10),
              sp: "RESOURCES MASTER",
              action: "EXCEL EXPORT",
              status: "SUCCESS",
              tableName: "mst_resources",
              description: `Resources Excel exported successfully. Total Records: ${rows.length}`,
            },
            "Log/IUDLog",
          );
        }
        exportData(
          ResourcesMasterExportHeader.map((col) => col.title),
          rows,
        );
      }
    } catch (error) {
      console.error("Export error", error);
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "RESOURCES MASTER",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: "mst_resources",
          description: error?.message || "Excel export failed",
        },
        "Log/IUDLog",
      );
      toast.error("Failed to export Excel 👎", {
        duration: 1000,
        position: "top-center",
      });
    }
  };
  const exportData = (columns, rows) => {
    /* ---------- TITLE ---------- */
    const titleRow = [
      {
        v: "Resource Person",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    const spacingRow = [{ v: "" }];

    /* ---------- HEADER ---------- */
    const headerRow = columns.map((col) => ({
      v: col,
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left", wrapText: true },
      },
    }));

    /* ---------- DATA ROWS ---------- */
    const dataRows = rows.map((row, index) => {
      const baseStyle =
        index % 2 === 1 ? { fill: { fgColor: { rgb: "F2F2F2" } } } : {};

      return [
        { v: index + 1, s: baseStyle }, // S.No
        { v: row.MstResourcesId, s: baseStyle },
        { v: row.ResourcesName, s: baseStyle },
        { v: row.ResourcesPosition, s: baseStyle },
        { v: row.StateName_en, s: baseStyle },
        { v: row.LocationName_en, s: baseStyle },
        { v: row.FullName_en, s: baseStyle },
      ];
    });

    /* ---------- SHEET DATA ---------- */
    const wsData = [titleRow, spacingRow, headerRow, ...dataRows];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ---------- DYNAMIC COLUMN WIDTHS (CORRECT) ---------- */
    ws["!cols"] = columns.map((header, colIndex) => {
      // start with header text length
      let maxLength = header?.length || 10;

      // check each exported row
      dataRows.forEach((rowArray) => {
        const cell = rowArray[colIndex]?.v;

        if (cell !== null && cell !== undefined) {
          maxLength = Math.max(maxLength, cell.toString().length);
        }
      });

      return {
        width: Math.min(Math.max(maxLength + 2, 10), 40),
      };
    });

    /* ---------- ROW HEIGHTS ---------- */
    ws["!rows"] = [
      { hpt: 30 }, // Title
      { hpt: 15 }, // Space
      { hpt: 22 }, // Header
      ...Array(rows.length).fill({ hpt: 18 }),
    ];

    /* ---------- BORDERS ---------- */
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = range.s.r; R <= range.e.r; R++) {
      for (let C = range.s.c; C <= range.e.c; C++) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[cellRef]) continue;

        ws[cellRef].s = {
          ...ws[cellRef].s,
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    }

    /* ---------- WORKBOOK ---------- */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Resource Person");

    XLSX.writeFile(wb, "Resource_Person.xlsx");
  };
  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Resource Person"
          header={ResourcesMasterHeader}
          records={bindResourcesMasterDatas}
          handleEdit={handleEdit}
          handleAction={handleResources}
          handleExportBtn={true}
          handleExport={handleExport}
          showAdd={showAdd}
          blockView={true}
        />
      )}
      {visibleAdd && (
        <div className="flex flex-col w-full">
          <div className={mainTable.mainAddScreen}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Resource Person"
            />
            <div className={mainTable.addShadowScreen}>
              <div className={mainTable.mainContentScreen}>
                <form className={mainTable.formForClientMaster}>
                  <div className={mainTable.grid3}>
                    <div>
                      <InputText
                        classStar="text-red-500"
                        inputType="text"
                        title="Resource Person Name"
                        name="resourcesName"
                        maxLength={200}
                        content={resourceFields.resourcesName}
                        placeholder="Resource Person Name"
                        controlFunc={(e) =>
                          setResourceFields({
                            ...resourceFields,
                            resourcesName: e.target.value,
                          })
                        }
                        controlFuncBlur={(e) => {
                          setResourceFieldsError((resourceFieldsError) => ({
                            ...resourceFieldsError,
                            resourcesNameError:
                              (resourceFields.resourcesName || "").length > 0
                                ? /^[A-Za-z -]+$/.test(
                                    resourceFields.resourcesName,
                                  )
                                  ? ""
                                  : "Only Alphabet, space and - allowed"
                                : " Enter Resource Person Name",
                          }));
                        }}
                        errorMessage={resourceFieldsError.resourcesNameError}
                      />
                    </div>
                    <div>
                      <InputText
                        classStar="text-red-500"
                        inputType="text"
                        title="Position"
                        maxLength={200}
                        name="resourcesPosition"
                        content={resourceFields.resourcesPosition}
                        placeholder="Position"
                        controlFunc={(e) =>
                          setResourceFields({
                            ...resourceFields,
                            resourcesPosition: e.target.value,
                          })
                        }
                        controlFuncBlur={(e) => {
                          setResourceFieldsError((resourceFieldsError) => ({
                            ...resourceFieldsError,
                            resourcesPositionError:
                              (resourceFields.resourcesPosition || "").length >
                              0
                                ? /^[A-Za-z -]+$/.test(
                                    resourceFields.resourcesPosition,
                                  )
                                  ? ""
                                  : "Only Alphabet, space and - allowed"
                                : " Enter Position",
                          }));
                        }}
                        errorMessage={
                          resourceFieldsError.resourcesPositionError
                        }
                      />
                    </div>
                    <AutoDropDown
                      classStar="text-red-500"
                      classDiv="hidden"
                      title="Country"
                      options={[]}
                      placeholder="Select"
                      name="country"
                      selectedOption={resourcesCountry}
                      controlFunc={(value) => {
                        setResourcesCountry(value);
                      }}
                      Class="custom-class"
                      disabled="true"
                      tabIndex="1"
                    />
                    <div>
                      <AutoDropDown
                        classStar="text-red-500"
                        title="State"
                        options={bindState}
                        placeholder="Select"
                        name="resourcesState"
                        Class="p-0"
                        selectedOption={bindState.find(
                          (x) => x.value == resourceFields.resourcesState,
                        )}
                        controlFunc={(value, e) => {
                          setResourceFields({
                            ...resourceFields,
                            resourcesLocation: "",
                          });

                          setResourceFieldsError({
                            ...resourceFieldsError,
                            resourcesStateError: value ? "" : "Select State",
                          });
                          handleUserFieldsChange(value.value, e.name);
                          setResourceFields({
                            ...resourceFields,
                            resourcesState: value.value,
                            resourcesLocation: "",
                          });
                        }}
                        controlFuncBlur={() => {
                          setResourceFieldsError({
                            ...resourceFieldsError,
                            resourcesStateError: resourceFields.resourcesState
                              ? ""
                              : "Select State",
                          });
                        }}
                        tabIndex="1"
                        errorMessage={resourceFieldsError.resourcesStateError}
                        setError={setResourceFieldsError}
                      />
                    </div>
                    <div>
                      <AutoDropDown
                        classStar="text-red-500"
                        title="Branch/Project"
                        options={bindLocation && bindLocation1}
                        placeholder="Select"
                        name="resourcesLocation"
                        Class="p-0"
                        selectedOption={
                          resourceFields.resourcesLocation
                            ? bindLocation.find(
                                (x) =>
                                  x.value == resourceFields.resourcesLocation,
                              )
                            : ""
                        }
                        controlFunc={(value, e) => {
                          setResourceFieldsError({
                            ...resourceFieldsError,
                            resourcesLocationError: value
                              ? ""
                              : "Select Branch/Project",
                          });
                          handleUserFieldsChange(value.value, e.name);
                        }}
                        controlFuncBlur={() => {
                          setResourceFieldsError({
                            ...resourceFieldsError,
                            resourcesLocationError:
                              resourceFields.resourcesLocation
                                ? ""
                                : "Select Branch/Project",
                          });
                        }}
                        tabIndex="1"
                        errorMessage={
                          resourceFieldsError.resourcesLocationError
                        }
                        setError={setResourceFieldsError}
                      />
                    </div>
                    <div className="col-span-2">
                      <FileUpload
                        title="Photo"
                        classDiv={mainTable.grid2}
                        apiCall="ResourcesAPI/ResourcesImageUpload"
                        modalName="Resources_Image"
                        showImage={resourceFields.showImage}
                        disabledBtn={updateScreenTitle}
                        showImageData={handleShowImage}
                        imageUploadedError={resourceFieldsError.showImageError}
                        limitMassage={
                          "Image size limit: 2MB. Accepted Image types:jpg, png, jpeg."
                        }
                        MAX_FILE_SIZE_MB={2}
                        ALLOWED_FORMATS={[
                          "image/jpeg",
                          "image/jpg",
                          "image/png",
                        ]}
                      />
                    </div>
                  </div>
                </form>
                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled ? true : false}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleResources}
      >
        <div>
          <PopUpScreenTitle
            title="Resource Person"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <ResourceMasterPopup data={currentData} data1={popupdata} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
}

export default ResourcesMaster;
